import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './HelpPage.css';

interface FAQItem {
  id: string;
  question: string;
  answer: string;
}

const HelpPage: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const faqItems: FAQItem[] = [
    {
      id: 'unsubscribe',
      question: t('help.faq.unsubscribe.question'),
      answer: t('help.faq.unsubscribe.answer')
    },
    {
      id: 'refund',
      question: t('help.faq.refund.question'),
      answer: t('help.faq.refund.answer')
    },
    {
      id: 'login',
      question: t('help.faq.login.question'),
      answer: t('help.faq.login.answer')
    }
  ];

  const handleFAQToggle = (faqId: string) => {
    // Navigate to answer page instead of just expanding
    navigate(`/help-answer?type=${faqId}`);
  };

  const handleContactUs = () => {
    // Navigate to contact page or open contact form
    navigate('/help-contact');
  };

  return (
    <div className="help-page">
      {/* FAQ Section */}
      <div className="help-faq-section">
        <h1 className="help-title">{t('help.title')}</h1>

        <div className="faq-list">
          {faqItems.map((item, index) => (
            <div key={item.id} className="faq-item">
              <button
                className="faq-question"
                onClick={() => handleFAQToggle(item.id)}
              >
                <span className="faq-question-text">{item.question}</span>
                <svg
                  className={`faq-chevron`}
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M6 12L10 8L6 4"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </button>

             <div className="faq-separator" />
            </div>
          ))}
        </div>
      </div>

      {/* Main Content Area - Empty space as shown in screenshot */}
      <div className="help-content-area">
        {/* This area is intentionally left empty as per the design */}
      </div>

      {/* Contact Us Button */}
      <div className="help-contact-section">
        <button className="contact-us-button" onClick={handleContactUs}>
          <div className="contact-icon">
            <img src="/images/ui/mail-plus.png" alt="Contact us" width="20" height="20" />
          </div>
          <span className="contact-text">{t('help.contact_us')}</span>
          <svg
            className="contact-chevron"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M6 12L10 8L6 4"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default HelpPage;
